import { configureStore } from "@reduxjs/toolkit";

import serverReducer from "./reducers/serverConnection/serverSlice";
import settingsReducer from "./reducers/settings/settingsSlice";
import currentDataReducer from "./reducers/currentData/currentDataSlice";
import userReducer from "./reducers/user/userSlice";
import examinationForm from "./reducers/examinationForm/examinationFormSlice";

export const store = configureStore({
  reducer: {
    serverReducer,
    settingsReducer,
    currentDataReducer,
    userReducer,
    examinationForm,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
